export const removeSubscriptionErrorsMutation = `
  mutation($subscriptionId: String!, $errorCode: String!) {
    removeSubscriptionErrors(subscriptionId: $subscriptionId, errorCode: $errorCode) {
      success {
        message
      }
      error {
        message
      }
      statusCode
    }
  }
`;

interface ISuccess {
  message: string;
}

interface IError {
  message: string;
}

export interface IRemoveSubscriptionErrorsResult {
  success: ISuccess;
  error: IError;
  statusCode: number;
}

export interface IRemoveSubscriptionErrorsResponse {
  removeSubscriptionErrors: IRemoveSubscriptionErrorsResult;
}
